import { render, staticRenderFns } from "./vehicleRepairList.vue?vue&type=template&id=2feac240"
import script from "./vehicleRepairList.vue?vue&type=script&lang=js"
export * from "./vehicleRepairList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports